import createReactComponent from '../createReactComponent';
export default createReactComponent('math-greater', 'IconMathGreater', [
  ['path', { d: 'M5 18l14 -6l-14 -6', key: 'svg-0' }],
]);
